import BASEUtils from '../../../../../@BASE/utils/BASEUtils';

const TmpL006 = (page, section) => {
  const media = [];
  const materials = [];
  const eMentors = [];
  const modifiedPage = {
    ...page,
    content: {
      core: {
        id: page.content.core.id,
        material: page.id
      },
      eMentor: page.content.eMentor
    }
  };

  const videoMedia = {
    ...page.content.media,
    page: page.id,
    id: page.id,
    src: page.label.toLowerCase().replaceAll('-', '_') + '.mp4',
    transcript:
      page?.content?.cc
        .map((item) => item.tl_text || item.text || '')
        .filter((text) => text)
        .join('\n') || ''
  };
  // add the media object to the media array
  media.push(videoMedia);

  // modify the media object to strip out the unnecessary data
  const video = {
    content: {
      cc: page.content.cc?.map((cc) => ({
        ...cc,
        id: BASEUtils.generateGUID()
      })),
      core: page.content.core,
      focus_points: page.content.focus_points,
      media: videoMedia,
      questions: page.content.questions,
      pageLabel: page.label
    },
    page: page.id,
    section: section,
    type: 'video'
  };

  // add the media object to the media array
  materials.push(video);
  // update the the ementor content with the page id
  if (page.content.eMentor) {
    page.content.eMentor.forEach((mentor) => {
      const eMentor = {
        ...mentor,
        page: page.id
      };
      eMentors.push(eMentor);
    });
  }

  // Inject page.id into each focus point if present
  if (page.content && Array.isArray(page.content.focus_points)) {
    page.content.focus_points.forEach((fp) => {
      fp.page = page.id;
    });
  }

  // Extract metadata separately
  const metadata = {
    media: media || [],
    images: [],
    materials: materials || [],
    eMentor: eMentors,
    focusPoints: page.content.focus_points || []
  };

  return { modifiedPage, metadata };
};

export default TmpL006;
